import { api } from '@/lib/axios';

export type AOStatut = 'IDENTIFIE' | 'EN_COURS' | 'DEPOSE' | 'REMPORTE' | 'PERDU' | 'INFRUCTUEUX' | 'ANNULE';
export type AOType = 'PUBLIC' | 'PRIVE' | 'GRE_A_GRE';
export type InteractionType = 'RENCONTRE' | 'APPEL' | 'COURRIER' | 'EMAIL' | 'AUTRE';

export interface Contact {
  id: string; tiers_id: string; nom: string; fonction: string | null;
  telephone: string | null; email: string | null; notes: string | null;
}
export interface ContactInput { nom: string; fonction?: string | null; telephone?: string | null; email?: string | null; notes?: string | null }

export interface Interaction {
  id: string; tiers_id: string | null; appel_offre_id: string | null; date: string;
  type: InteractionType; resume: string | null; par_qui_id: string | null; par_qui_nom: string | null;
}
export interface InteractionInput { tiers_id?: string | null; appel_offre_id?: string | null; date: string; type: InteractionType; resume?: string | null }

export interface PipelineOpp {
  id: string; reference: string; intitule: string; client_id: string | null; client_nom: string | null;
  type: AOType; type_marche: string | null; montant_estimatif: string; probabilite: number;
  date_limite_depot: string | null; valeur_ponderee: string;
}
export interface PipelineColonne { statut: AOStatut; opportunites: PipelineOpp[]; total_montant: string; total_pondere: string }
export interface PipelineResp { colonnes: PipelineColonne[] }

export interface Organisme {
  id: string; raison_sociale: string; secteur: string | null; wilaya_id: number | null;
  telephone: string | null; email: string | null; nb_contacts: number; nb_opportunites: number; ca_marches: string;
}

export interface ReportingResp {
  annee: number | null;
  nb_par_statut: Record<string, number>;
  taux_reussite_pct: number;
  remportes: number; perdus: number;
  pipeline_pondere: string;
  repartition_type: Record<string, { nb: number; montant: string }>;
  ca_par_donneur: { donneur: string; ca: string }[];
}

export async function listContacts(tiersId: string): Promise<Contact[]> {
  const { data } = await api.get<Contact[]>(`/tiers/${tiersId}/contacts`);
  return data;
}
export async function createContact(tiersId: string, payload: ContactInput): Promise<Contact> {
  const { data } = await api.post<Contact>(`/tiers/${tiersId}/contacts`, payload);
  return data;
}
export async function updateContact(id: string, payload: ContactInput): Promise<Contact> {
  const { data } = await api.put<Contact>(`/contacts/${id}`, payload);
  return data;
}
export async function deleteContact(id: string): Promise<void> {
  await api.delete(`/contacts/${id}`);
}
export async function listInteractions(filtres?: { tiers_id?: string; appel_offre_id?: string }): Promise<Interaction[]> {
  const { data } = await api.get<Interaction[]>('/crm/interactions', { params: filtres ?? {} });
  return data;
}
export async function createInteraction(payload: InteractionInput): Promise<Interaction> {
  const { data } = await api.post<Interaction>('/crm/interactions', payload);
  return data;
}
export async function deleteInteraction(id: string): Promise<void> {
  await api.delete(`/crm/interactions/${id}`);
}
export async function getPipeline(filtres?: { type?: AOType; wilaya_id?: number }): Promise<PipelineResp> {
  const { data } = await api.get<PipelineResp>('/crm/pipeline', { params: filtres ?? {} });
  return data;
}
export async function patchOpportunite(aoId: string, payload: { statut?: AOStatut; probabilite?: number; type_marche?: string | null; resultat_motif?: string | null }): Promise<unknown> {
  const { data } = await api.patch(`/crm/opportunites/${aoId}`, payload);
  return data;
}
export async function listOrganismes(): Promise<Organisme[]> {
  const { data } = await api.get<Organisme[]>('/crm/organismes');
  return data;
}
export async function getReporting(annee?: number): Promise<ReportingResp> {
  const { data } = await api.get<ReportingResp>('/crm/reporting', { params: annee ? { annee } : {} });
  return data;
}
